import * as _ from 'lodash'

/**
 * Immutable Map
 */
export default class ImmutableMap<IMap> {
  constructor(private data: IMap) { }

  /**
   * Get a copy of an attribute from given key
   * @param key
   */
  get<K extends keyof IMap>(key: K): IMap[K] {
    const singleData = this.data[key]

    return this.clone(singleData)
  }

  /**
   * Get copy of nested value
   * @param key
   * @param subkey
   */
  getNested<K extends keyof IMap, L extends keyof IMap[K]>(key: K, subkey: L): IMap[K][L] {
    const singleData = this.data[key][subkey]

    return this.clone(singleData)
  }

  /**
   * Get copy of nested nested value
   * @param key
   * @param subkey
   */
  getNestedNested<K extends keyof IMap, L extends keyof IMap[K], M extends keyof IMap[K][L]>(key: K, subkey: L, subsubkey: M): IMap[K][L][M] {
    const singleData = this.data[key][subkey][subsubkey]

    return this.clone(singleData)
  }

  getNative<K extends keyof IMap>(key: K): IMap[K] {
    return this.data[key]
  }

  /**
   * Get several keys attributes at once
   * @param keys
   */
  getSome<K extends keyof IMap>(...keys: K[]): Pick<IMap, K> {
    // tslint:disable-next-line:no-object-literal-type-assertion
    const subState = {} as Pick<IMap, K>

    keys.forEach(
      (key) => subState[key] = this.get(key)
    )

    return subState
  }

  /**
   * Returns a new Map with the updated key/value
   * @param updatedSubState
   */
  update<K extends keyof IMap>(updatedSubState: Pick<IMap, K>): ImmutableMap<IMap> {
    const newData = _.extend({}, this.data, updatedSubState)

    return new ImmutableMap(newData)
  }

  /**
   * Returns a deep clone for objects, the value otherwise
   * @param data
   */
  private clone<T>(data: T) {
    if (typeof data === 'object' && data !== null) {
      data = _.cloneDeep(data)
    }

    return data
  }

  /**
   * Get copy of underlying data
   */
  // unpack(): IMap {
  //   return _.cloneDeep(this.data)
  // }
}



// WEBPACK FOOTER //
// ./src/app/utils/immutable/map/index.ts